<div class="main_container">
<section id="section_1" fragment="section_1">
    <div class="hr bg-brand top"></div>
    <div class="cover-img" style="background-image: url('assets/images/images_1.jpg')">
        <div class="content">
            <div class="heading_1"><img src="/assets/images/text_1.svg" width=60%></div>
            <div class="heading_2"><img src="/assets/images/logo.svg" width=45%></div>
            <div class="heading_3"><img src="/assets/images/text_2.svg" width=41%></div>
            <div class="heading_4"><img src="/assets/images/text_3.svg" width=41%></div>
        </div>
    </div>
    <div class="hr bg-brand bottom"></div>
</section>
<section id="section_2" fragment="section_2">
    <div class="marble-pattern"></div>
    <div class="content">
        <div class="heading_1"><img src="/assets/images/text_4.svg" width=90%></div>
        <div class="heading_2"><img src="/assets/images/text_5.svg" width=75%></div>
        <div class="heading_3"><img src="/assets/images/text_6.svg" width=65%></div>
    </div>
    <div class="leaf"><img src="/assets/images/leaf.svg"></div>
</section>
<section id="section_3" fragment="section_3">
    <div class="cover-img" style="background-image: url('assets/images/images_2.jpg')">
        <div class="remark"><img src="/assets/images/remark_1.svg"></div>
        <div class="content">
            <div class="heading_1"><img src="/assets/images/text_7.svg"></div>
        </div>
    </div>
    <div class="description bg-brand">
        <img src="/assets/images/text_8.svg">
    </div>
    <div class="hr marble-pattern"></div>
</section>
<section id="section_4" fragment="section_4">
    <div class="cover-img" style="background-image: url('assets/images/images_3.jpg')">
        <div class="remark"><img src="/assets/images/remark_1.svg"></div>
        <div class="content">
            <div class="heading_1"><img src="/assets/images/text_9.svg"></div>
            <div class="overlay"></div>
        </div>
    </div>
    <div class="description bg-brand">
        <img src="/assets/images/text_10.svg">
    </div>
    <div class="hr marble-pattern"></div>
</section>
<section id="section_5" fragment="section_5">
    <div class="cover-img" style="background-image: url('assets/images/images_4.jpg')">
        <div class="remark"><img src="/assets/images/remark_1.svg"></div>
        <div class="content">
            <div class="heading_1"><img src="/assets/images/text_11.svg"></div>
            <div class="overlay"></div>
        </div>
    </div>
    <div class="description bg-brand">
        <img src="/assets/images/text_12.svg">
    </div>
</section>
<section id="section_6" fragment="section_6">
    <div class="leaf"><img src="/assets/images/leaf.svg"></div>
    <div class="cover-img" style="background-image: url('assets/images/images_5.jpg')">
        <div class="remark"><img src="/assets/images/remark_2.svg"></div>
        <div class="content">
            <div class="heading_1"><img src="/assets/images/text_13.svg"></div>
            <div class="overlay"></div>
        </div>
    </div>
    <div class="description bg-brand">
        <img src="/assets/images/text_14.svg">
    </div>
</section>
<section id="section_7" fragment="section_7">
    <div class="row">
        <div class="col-4">
            <div class="cover-img" style="background-image: url('assets/images/images_6.jpg')">
                <div class="remark"><img src="/assets/images/remark_3.svg"></div>
            </div>
        </div>
        <div class="col-8">
            <div class="cover-img" style="background-image: url('assets/images/images_7.jpg')">
                <div class="remark"><img src="/assets/images/remark_4.svg"></div>
            </div>
        </div>
        <div class="col-12">
            <div class="cover-img w-full" style="background-image: url('assets/images/images_8.jpg')">
                <div class="remark right"><img src="/assets/images/remark_5.svg"></div>
                <div class="content">
                    <div class="heading_1"><img src="/assets/images/text_15.svg"></div>
                    <div class="overlay"></div>
                </div>
            </div>
            <div class="description bg-brand">
                <img src="/assets/images/text_16.svg">
            </div>
        </div>
    </div>
</section>
<section id="section_8" fragment="section_8">
    <div class="row">
        <div class="col-8">
            <div class="cover-img" style="background-image: url('assets/images/images_9.jpg')">
                <div class="remark right"><img src="/assets/images/remark_6.svg"></div>
            </div>
        </div>
        <div class="col-4">
            <div class="cover-img" style="background-image: url('assets/images/images_10.jpg')">
                <div class="remark"><img src="/assets/images/remark_7.svg"></div>
            </div>
        </div>
        <div class="col-12">
            <div class="cover-img w-full" style="background-image: url('assets/images/images_11.jpg')">
                <div class="remark right"><img src="/assets/images/remark_8.svg"></div>
                <div class="content">
                    <div class="heading_1"><img src="/assets/images/text_17.svg"></div>
                    <div class="overlay"></div>
                </div>
            </div>
            <div class="description bg-brand">
                <img src="/assets/images/text_18.svg">
            </div>
        </div>
    </div>
</section>
<section id="section_9" fragment="section_9">
    <div class="marble-pattern"></div>
    <div class="hr bg-brand"></div>
    <div class="cover-img" style="background-image: url('assets/images/images_12.jpg')"></div>
    <div class="cover-img" style="background-image: url('assets/images/images_13.jpg')">
        <div class="remark"><img src="/assets/images/remark_1.svg"></div>
    </div>
    <div class="content">
        <div class="heading_1"><img src="/assets/images/text_19.svg"></div>
        <div class="heading_2"><img src="/assets/images/text_20.svg"></div>
        <div class="heading_3"><img src="/assets/images/text_21.svg"></div>
        <div class="heading_4"><img src="/assets/images/text_22.svg"></div>
    </div>
    <div class="leaf"><img src="/assets/images/leaf.svg"></div>
    <div class="hr bg-brand"></div>
</section>
<section id="section_10" fragment="section_10">
    <div class="marble-pattern"></div>
    <div class="row">
        <div class="col-7">
            <div class="cover-img img-1" style="background-image: url('assets/images/images_14.jpg')">
                <div class="remark pl"><img src="/assets/images/remark_9.svg"></div>
            </div>
        </div>
        <div class="col-5">
            <div class="row">
                <div class="col-12">
                    <div class="cover-img img-2" style="background-image: url('assets/images/images_15.jpg')">
                        <div class="remark"><img src="/assets/images/remark_10.svg"></div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="cover-img img-3" style="background-image: url('assets/images/images_16.jpg')">
                        <div class="remark"><img src="/assets/images/remark_11.svg"></div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="cover-img img-4" style="background-image: url('assets/images/images_17.jpg')">
                        <div class="remark"><img src="/assets/images/remark_12.svg"></div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="cover-img img-5" style="background-image: url('assets/images/images_18.jpg')">
                        <div class="remark right pr"><img src="/assets/images/remark_13.svg"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content">
        <div class="heading_1"><img src="/assets/images/text_23.svg"></div>
        <div class="heading_2"><img src="/assets/images/text_24.svg"></div>
    </div>
</section>
<section id="section_11" fragment="section_11">
    <div class="hr bg-brand top"></div>
    <div class="cover-img" style="background-image: url('assets/images/images_19.jpg')"></div>
    <div class="content">
        <div class="heading_1">
            <img src="/assets/images/logo.svg" width=45%>
        </div>
        <div class="heading_2">
            <img src="/assets/images/text_25.svg" width=55%>
        </div>
        <div class="heading_3">
            <img src="/assets/images/text_26.svg" width="55%">
        </div>
        <div class="heading_4">
            <img src="/assets/images/text_27.svg" width="41%">
            <a href="#"><img src="/assets/images/icon_facebook.svg" width="7%"></a>
            <a href="#"><img src="/assets/images/icon_line.svg" width="7%"></a>
        </div>
        <div class="map_container">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.19090948039!2d121.52051681498827!3d25.061517743341774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9439fee2baf%3A0x33f96f68b453eb7!2zMTA0OTHlj7DljJfluILkuK3lsbHljYDkuK3lsbHljJfot6_kuozmrrUxMjbomZ8!5e0!3m2!1szh-TW!2stw!4v1604246240721!5m2!1szh-TW!2stw"
                frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
        <div class="heading_5"><img src="/assets/images/text_28.svg" width="40%"></div>
        <div class="form_container">
            <form>
                <div class="form-group row">
                    <label for="name" class="col-2">姓名</label>
                    <div class="col-10">
                        <input type="email" class="form-control" id="name">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="mail" class="col-2">信箱</label>
                    <div class="col-10">
                        <input type="email" class="form-control" id="mail">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="mark" class="col-2">備註</label>
                    <div class="col-10">
                        <textarea class="form-control" id="mark" rows="3"></textarea>
                    </div>
                </div>
                <button type="submit" class="btn btn-brand">送出</button>
            </form>
        </div>
    </div>
    <div class="hr bg-brand bottom"></div>
</section>
</div>
<div class="sidebar">
    <nav class="navbar_container" id="navbar">
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_1" class="nav_item nav-link">首頁</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_2" class="nav_item nav-link">相遇敦年</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_3" class="nav_item nav-link">戶戶林蔭</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_4" class="nav_item nav-link">首善中山</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_5" class="nav_item nav-link">金融重鎮</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_6" class="nav_item nav-link">在地人文</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_7" class="nav_item nav-link">時尚精品</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_8" class="nav_item nav-link">定級饗宴</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_9" class="nav_item nav-link">國際質感</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_10" class="nav_item nav-link">精品建材</a>
        <a pageScroll [pageScrollAdjustHash]="true" href="#section_11" class="nav_item nav-link">預約鑑賞</a>
    </nav>
</div>
